import { styled, Typography } from '@mui/material';
import { FontWeights } from 'theme/Typography';

export const RowBoldText = styled(Typography)({
  fontSize: 18,
  lineHeight: '24px',
  fontWeight: FontWeights.fontWeightSemiBold,
  textAlign: 'center',
});
